import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=0b1ce0dc&scoped=true&"
import script from "./CaseForm.vue?vue&type=script&lang=js&"
export * from "./CaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CaseForm.vue?vue&type=style&index=1&id=0b1ce0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ce0dc",
  null
  
)

export default component.exports